<template>
<div class="flex flex-1 flex-col items-center mt-4">
  <div class="cstm_vuefileagent_holder w-full">
    <VueFileAgent
      :disabled="edit_permission() ? false : true"
      @isBrowseContent="isBrowseContent = true"
      class="w-full"
      multiple="false"
      ref="vueFileAgent"
      :theme="theme"
      :deletable="true"
      :meta="true"
      :maxSize="'10000MB'"
      :helpText="imageHint"
      :errorText="{
        type: 'Invalid file type. Only images Allowed',
        size: 'Files should not exceed 10MB in size',
      }"
      @select="filesSelected($event)"
      @beforedelete="onBeforeDelete($event)"
      @delete="fileDeleted($event)"
      v-model="fileRecords"
     @upload:error="uploadEvent('upload:error', $event)"

    ></VueFileAgent>

    <p class="or_text_holder">(or)</p>
    <div class="" v-if="edit_permission()">
      <vs-tooltip class="inline-block align-bottom" color="primary"
        text="Import File From Your Existing System"
      >
        <vs-button
          icon="folder_special"
          class="mb-6 mx-1 icon_large_btn"
          color="primary"
          type="border"
          @click="isBrowseContent = true"
          ></vs-button
        >
      </vs-tooltip>

      <vs-tooltip class="inline-block align-bottom" color="primary"
        text="Select files From Gdrive"
      >
        <vs-button
          class="mb-6 mx-1 icon_large_btn includeIcon includeIconOnly"
          color="primary"
          type="border"
          @click="driveIconClicked()"
          >
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "/><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "/><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "/></g></svg>
        </vs-button>
      </vs-tooltip>
    </div>
  </div>

    <div v-if="fileRecordsForUpload.length">
    <vs-divider/>
    <vs-button :disabled="!fileRecordsForUpload.length" @click="uploadFiles()">
      Upload {{ fileRecordsForUpload.length }} {{ fileRecordsForUpload.length > 1 ? 'files' : 'file' }}
    </vs-button>
    </div>

    <div v-if="isBrowseContent">
      <vs-popup fullscreen title="Browse Item" :active.sync="isBrowseContent" class="browse_modal_item">
        <import-browse-files-model
          v-if="isBrowseContent"
          :multipleSelect="false"
          :file_repository_id="file_repository_id"
          @getImportFile="getImportFile"
        ></import-browse-files-model>
      </vs-popup>
    </div>

  </div>
</template>

<script>
import {GoogleAuthorization} from '@/mixins/common/GoogleAuthorization.js'
import { getUploadedFilesId } from '@/api/assignment-question'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'

export default {
  name: 'FileTesting',
  components: { ImportBrowseFilesModel },
  mixins:[GoogleAuthorization],
  props: {
    addpopup:{

    },
    file_repository_id:{
      required:false,
      type:Number,
      default:0
    },
    acceptFiles: {
      type: String,
      default: ''
    },
    acceptGDriveFiles: {
      type: String,
      default: ''
    },
    edit_permission: {
      type: Function,
      required: false,
      default: () => {
        return true
      }
    }
  },
  watch: {
    addpopup:{
      handler () {
        console.log(this.addpopup)
        if (!this.addpopup) {
          this.fileRecords = ''
        }
      }
    }
    
  },
  data () {
    return {
      multipleSelect: false,
      isBrowseContent: false,
      deletedIndex: null,
      isCollapseCard:true,
      theme:'grid',
      imageHint:'Choose file or drag & drop here',
      imagevalidation: 'image/*',
      fileTypeValidation: this.acceptGDriveFiles,
      auto: true,
      fileRecords: '',
      uploadUrl: '',
      ///file/upload/${platform_customer_id}
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent', 'Authorization': '' },
      fileRecordsForUpload: [] // maintain an upload queue
    }
  },
  // config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`

  created () {
    const customer_id = this.$store.getters.customerId

    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.uploadUrl = `${imageUploadUrl}${customer_id}`
    this.uploadHeaders.Authorization = `Bearer ${JSON.parse(
      localStorage.getItem('access_token')
    )}`
    //this.imagevalidation = 'image/*'
    //this.imageHint = 'Choose/drag & drop here'
  },
  methods: {
    uploadEvent () {

    },
    uploadFiles () {
      const data = this.$refs.vueFileAgent.upload(
        this.uploadUrl,
        this.uploadHeaders,
        this.fileRecordsForUpload,
        function createFormData (fileData) {


          const formData = new FormData()
          formData.append('files[]', fileData.file) // this is important! - the actual file for upload
          return formData // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
        }
      )


      this.$vs.loading({
        type:'material',
        text:'Please wait we are uploading files'
      })


      data.then((response) => {
        const cdn = response[0].data.data.cdn
        if (response) {

          for (let i = 0;  i < response.length; i++) {

            const file_name = response[i].data.data.files[0].file_name
            const file_path = response[i].data.data.files[0].file_path

            const raw = JSON.stringify({
              file_repository_id: this.file_repository_id,
              files: [
                {
                  file_name,
                  file_path: `${cdn}${file_path}`
                }
              ]
            })

            const file_id_payload = raw
            this.getUploadFiles(file_id_payload)
          }
          this.$vs.loading.close()
        } else {
          this.$vs.loading.close()
        }
      })
        .catch(error => {
          this.$vs.loading.close()
          console.log(error)

        })
        .finally(this.$vs.loading.close())

      this.fileRecordsForUpload = []
    },
    async getUploadFiles (file_id_payload, type = 'system') {

      try {
        const res = await getUploadedFilesId(file_id_payload)
        console.log(res)

        if (res.data.message === 'files.createFile') {
          this.$emit('getFileId', res.data.data.files[0].files_id)

          const fileObject = {
            files_id:res.data.data.files[0].files_id,
            files_repository_id:this.file_repository_id,
            file_image_url:res.data.data.files[0].file_path

          }

          // this.$emit('getImage', fileObject)

          // this.filesInfo.push(file)

          // console.log()
          const filesDriveInfo = res.data.data.files
          console.log(filesDriveInfo)
          let filesDrive = []
        
    
          if (type === 'drive') {
            
            filesDrive = filesDriveInfo.map(ele => {
              return {
                name: ele.file_name,
                sizeText: this.bytesToSize(ele.size),
                size: ele.size,
                type: ele.file_type,
                url: ele.file_path,
                color: 'green',
                upload: {
                  data: true,
                  error: false
                }
              }
            })
            console.log(filesDriveInfo)


            this.fileRecords = filesDrive
            

            console.log(filesDrive)
            const repo_id = this.files_repository_id
            console.log(repo_id)
            filesDriveInfo.forEach(ele => {
              console.log(repo_id)
              console.log(ele)
 
              this.$emit('getImage', {
                files_id:ele.files_id,
                files_repository_id:this.file_repository_id,
                file_image_url:ele.file_path
              })

            })
            this.$vs.notify({
              title: 'Success',
              text: 'File Uploaded Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
              time: 1000
            })
          } else {
            this.$emit('getImage', fileObject)

          }   
          this.$vs.loading.close()
        }
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    deleteUploadedFile () {
      this.$emit('deletedIndex', this.deletedIndex)
    },
    filesSelected (fileRecordsNewlySelected) {


      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error)

      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      )

    },
    onBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else if (confirm('Are you sure you want to delete?')) {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
      }
    },
    acceptAlert (fileRecord) {
      const index = this.fileRecords.indexOf(fileRecord)
      this.deletedIndex = index
      this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
    },
    fileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        this.deleteUploadedFile(fileRecord)
      }
    },
    bytesToSize (bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
    },
    getImportFile ({ file_id, fileInfo }) {
      console.log(file_id)
      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)
      
      const importFileRecords = this.getImportedFile(fileInfo)
      console.log('imported', importFileRecords)

      fileInfo.forEach(ele => {
        const fileObject = {
          files_id:ele.files_id,
          files_repository_id:this.file_repository_id,
          file_image_url:ele.file_path
        }
        this.$emit('getImage', fileObject)

      })

      this.fileRecords = importFileRecords
      this.$emit('getFileId', file_id[0])
      
      
    },
    generateFileForVueAgent (ele) {
      return {
        file_id: ele.file.id,
        name: ele.file.file_name,
        sizeText: this.bytesToSize(ele.file.size),
        size: ele.file.size,
        type: ele.file.file_type,
        url: ele.file.file_path,
        upload: {
          data: true,
          error: false
        }
      }
    },
    getImportedFile (fileInfo) {
      console.log('file info', fileInfo)
      return fileInfo.map((ele) => {
        return {
          name: ele.file_name,
          sizeText: this.bytesToSize(ele.size),
          size: ele.size,
          type: ele.file_type,
          url: ele.file_path,
          color: 'green',
          upload: {
            data: true,
            error: false
          }
        }
      })
    }
  }
  
}
</script>
